import tableTotalAvg from "../../../objects/CommonUse/table_total_avg";

export const estimateUnplannedExpenses=(turnCashAmtArr, turnCreditAmtArr) =>{
    let unplannedAmtArr = [];
    // don't process the last one in turnCashAmtArr as it will be 0 (for next month)
    const nbrEntries = turnCashAmtArr.length - 1;
    for (let i=0; i<nbrEntries; i++){
            const turnCashAmt = turnCashAmtArr[i];
            let turnCreditAmt = 0;
            if (turnCreditAmtArr &&
                turnCreditAmtArr[i]){
                turnCreditAmt = turnCreditAmtArr[i]
            }
            const totalTurnAmt = +turnCashAmt + +turnCreditAmt;
            unplannedAmtArr.push(totalTurnAmt);
    }
    const unplannedExpensesObj = tableTotalAvg(unplannedAmtArr, true);
    return unplannedExpensesObj;
}
export default estimateUnplannedExpenses;